export enum STORAGE {
  HAS_SUBSCRIPTION_CONFIRMATION_TOAST_BEEN_SHOWN = 'hasSubscriptionConfirmationToastBeenShown',
}

export default STORAGE;
